import { Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

// Shown in place of the introduced-through tags when none of isDirect,
// isIndirect, fromBaseImage or fromThirdParty is set
export const IntroducedThroughUndetermined = () => {
  const { t } = useTranslation()

  return <Text type="secondary">{t("general.undetermined")}</Text>
}
